import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid";

function BeaconDataTable() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 100,
    page: 0,
  });
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL}/api/v1/beacon/all/data?page=${paginationModel.page + 1}&page_size=${paginationModel.pageSize}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const responseData = await response.json();
        setData(responseData.results || []);
        setTotalRows(responseData.total || 0);
        setLoading(false)

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [paginationModel]);

  // const handlePageChange = (params) => {
  //   setPage(params.page);
  // };

  // const handlePageSizeChange = (params) => {
  //   setPageSize(params.pageSize);
  // };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      headerAlign: "center",
      align: "center",
      filterable: false,
      renderHeader: () => <strong style={{ color: "#334474" }}>{"ID"}</strong>,
    },
    {
      field: "ts",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "#334474" }}>{"Timestamp"}</strong>
      ),
    },
    {
      field: "device_id",
      headerName: "Device ID",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "#334474" }}>{"Device ID"}</strong>
      ),
    },
    {
      field: "mac",
      headerName: "MAC",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => <strong style={{ color: "#334474" }}>{"MAC"}</strong>,
    },
    {
      field: "rssi",
      headerName: "RSSI",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "#334474" }}>{"RSSI"}</strong>
      ),
    },
    {
      field: "battery",
      headerName: "Battery",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "#57926e" }}>{"Battery"}</strong>
      ),
    },
    {
      field: "temperature",
      headerName: "Temperature",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "#f07979" }}>{"Temperature"}</strong>
      ),
    },
    {
      field: "humidity",
      headerName: "Humidity",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "#e9c46a" }}>{"Humidity"}</strong>
      ),
    },
  ];

  return (
    <div style={{ height: 400, width: "100%" }}>
      {/* <DataGrid
        rows={data}
        columns={columns}
        pagination
        pageSize={pageSize}
        rowCount={totalRows}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
      /> */}
      <DataGrid
        rows={data}
        columns={columns}
        density="compact"
        rowSelection={false}
        loading={loading}
        rowCount={totalRows}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        paginationMode="server"
        components={{
          Toolbar: GridToolbar,
          FilterPanel: GridFilterPanel,
        }}
        slotProps={{
          filterPanel: {
            sx: {
              width: "100%",          // full width responsive
              maxWidth: "100%",
              padding: "10px",
              "& .MuiDataGrid-filterForm": {
                flexDirection: "column",
                gap: "10px",
              },
            },
          },
        }}
      />
    </div>
  );
}

export default BeaconDataTable;
